export default __webpack_public_path__ + "static/media/service1.e92a30ec.jpeg";